import CorporateFareOutlinedIcon from '@mui/icons-material/CorporateFareOutlined';
import ManageAccountsOutlinedIcon from '@mui/icons-material/ManageAccountsOutlined';
import DevicesOutlinedIcon from '@mui/icons-material/DevicesOutlined';

const icons = {
  CorporateFareOutlinedIcon,
  ManageAccountsOutlinedIcon,
  DevicesOutlinedIcon
};

const outeradmin = {
  id: 'group-outeradmin',
  title: 'Admin',
  type: 'group',
  admin: false,
  outeradmin: true,
  children: [
    {
      id: 'outeradmin_plant',
      title: '발전소 관리',
      type: 'item',
      url: '/admin/plant',
      icon: icons.CorporateFareOutlinedIcon,
      breadcrumbs: false
    },
    {
      id: 'outeradmin_account',
      title: '사용자 관리',
      type: 'item',
      url: '/admin/account',
      icon: icons.ManageAccountsOutlinedIcon,
      breadcrumbs: false
    },
    {
      id: 'outeradmin_device',
      title: '장치 관리',
      type: 'item',
      url: '/admin/device',
      icon: icons.DevicesOutlinedIcon,
      breadcrumbs: false
    }
  ]
};

export default outeradmin;
